declare const window: any;

export const config = {
  backendUrl: !window._env_.backendUrl.startsWith("http") ? "http://localhost:3002" : window._env_.backendUrl,
  testdata: false,
};
